// extracted by mini-css-extract-plugin
export default {"complianceContainer":"ComplianceCheck_complianceContainer__9xGH1","complianceInnerContainer":"ComplianceCheck_complianceInnerContainer__1oG-N"};